import payment from './payment';
import order from './order';
import group from './group';
import product from './product';
//import customer from './customer';
import sale from './sale';
import user from './user';
import payoutAccount from './payout-account';
import paymentUser from './payment-user';
import auth from './auth';
import membership from './membership';
import bankid from './bankid';

export default {
  membership,
  user,
  sale,
  payment,
  order,
  group,
  product,
  //  customer,
  payoutAccount,
  paymentUser,
  auth,
  bankid,
};
